import React from 'react';

import { type EmojiId } from '@app/client/common/structs/emoji/emoji';

import { Chip, ChipColor, type ChipProps, ChipSize } from '../../Chip';
import { ChipYat } from '../ChipYat';

import { ChipMemberInterior, ChipYatWrapper, TwitterHandle, TwitterHandleWrapper, UsernameWrapper } from './styles';

export interface ChipMemberProps extends Pick<ChipProps, 'color' | 'size' | 'to'> {
    yat?: EmojiId;
    twitter?: string;
    username?: string;
    // TODO: Do we actually want this prop?
    spaceAroundYat?: boolean;
    // TODO: `active` prop is redundant and we should
    // instead utilize the `color` prop.
    active?: boolean;
}

export function ChipMember({
    yat,
    twitter,
    username,
    to,
    color = ChipColor.Default,
    size = ChipSize.Medium,
    spaceAroundYat = false,
    active = false,
}: ChipMemberProps) {
    // TODO: This label doesn't actually add value. If we want to
    // provide a label, it should be more informative.
    const ariaLabel = [yat, twitter].filter(Boolean).join(' | ');

    const isActive = active || color === ChipColor.Active;

    const chipYatMarkup = yat?.length ? (
        <ChipYatWrapper>
            <ChipYat yat={yat} size={size} />
        </ChipYatWrapper>
    ) : null;

    // TODO: Do we actually need this `@` check?
    const twitterHandleMarkup = twitter?.length ? (
        <TwitterHandleWrapper>
            <TwitterHandle>{twitter.startsWith('@') ? twitter : `@${twitter}`}</TwitterHandle>
        </TwitterHandleWrapper>
    ) : null;

    // TODO - get actual designs for username
    const usernameMarkup = username?.length ? (
        <UsernameWrapper>
            <TwitterHandle>{username}</TwitterHandle>
        </UsernameWrapper>
    ) : null;

    // TODO: Both `yat` and `twitter` are optional.
    // What happens when neither is provided?
    return (
        <Chip ariaLabel={ariaLabel} color={isActive ? ChipColor.Active : color} size={size} to={to}>
            <ChipMemberInterior $color={color} $size={size} $spaceAroundYat={spaceAroundYat}>
                {chipYatMarkup}
                {twitterHandleMarkup}
                {usernameMarkup}
            </ChipMemberInterior>
        </Chip>
    );
}
